<script setup>
import NavigationBar from "@/components/NavigationBar.vue";
import FooterComponent from "@/components/Components/FooterComponent.vue";
import SurveySecondaryComponent from "@/components/Components/SurveyLegacyC3edcfd/SurveySecondaryComponent.vue";
import SurveyDetailsComponent from "@/components/Components/SurveyLegacyC3edcfd/SurveyDetailsComponent.vue";
import SurveyAppComponent from "@/components/Components/SurveyLegacyC3edcfd/SurveyAppComponent.vue";
import {useI18n} from "vue-i18n";

const { t } = useI18n();
</script>

<template>
  <div class="container">
    <NavigationBar/>
  </div>

  <div class="container-fluid luma-embed-container">
    <div class="luma-embed">
      <iframe
        src="https://luma.com/embed/event/evt-2uVGNZHl605kFHh/simple"
        width="100%"
        height="600"
        frameborder="0"
        style="border: 1px solid #bfcbda88; border-radius: 4px;"
        allow="fullscreen; payment"
        aria-hidden="false"
        tabindex="0"
      ></iframe>
    </div>
  </div>

  <div class="container">
    <div class="mx-md-5 px-md-5 my-5">
      <SurveySecondaryComponent/>
      <div class="mt-5" v-if="false">
        <SurveyDetailsComponent/>
      </div>
      <!-- Hide Momfident info section for now (keep code to re-enable later) -->
      <div class="mt-5" v-if="false">
        <SurveyAppComponent/>
      </div>
    </div>
    <div class="mt-5">
      <div class="partners-title mb-5">
        {{ t('survey-partners-title') }}
      </div>
      <div class="row">
        <div class="logo col-md-3">
          <a href="https://www.bg-mamma.com/" target="_blank">
            <img src="@/assets/images/partners/logos/11.png" alt=""/>
          </a>
        </div>
        <div class="logo col-md-3">
          <a href="https://mama.radostna.com/" target="_blank">
            <img src="@/assets/images/partners/logos/1.png" alt=""/>
          </a>
        </div>
        <div class="logo col-md-3">
          <a href="https://misia-mama.com/bg/" target="_blank">
            <img src="@/assets/images/partners/logos/2.png" alt=""/>
          </a>
        </div>
        <div class="logo col-md-3">
          <a href="https://www.framar.bg/" target="_blank">
            <img src="@/assets/images/partners/logos/3.png" alt=""/>
          </a>
        </div>
        <div class="logo col-md-3">
          <a href="https://iphs.eu/en/" target="_blank">
            <img src="@/assets/images/partners/logos/4.png" alt=""/>
          </a>
        </div>
        <div class="logo col-md-3">
          <a href="https://sofiatech.bg/en/" target="_blank">
            <img src="@/assets/images/partners/logos/5.png" alt=""/>
          </a>
        </div>
        <div class="logo col-md-3">
          <a href="https://businesslab.bg/obstnost/" target="_blank">
            <img src="@/assets/images/partners/logos/6.png" alt=""/>
          </a>
        </div>
        <div class="logo col-md-3">
          <a href="https://parentacademy.bg/" target="_blank">
            <img src="@/assets/images/partners/logos/7.png" alt=""/>
          </a>
        </div>
        <div class="logo col-md-3">
          <a href="https://momgotajob.com/" target="_blank">
            <img src="@/assets/images/partners/logos/8.png" alt=""/>
          </a>
        </div>
        <div class="logo col-md-3">
          <a href="https://rinkercenter.org/" target="_blank">
            <img src="@/assets/images/partners/logos/9.png" alt=""/>
          </a>
        </div>
        <div class="logo col-md-3">
          <a href="https://momvy.eu/" target="_blank">
            <img src="@/assets/images/partners/logos/10.png" alt=""/>
          </a>
        </div>
        <div class="logo col-md-3">
          <a href="https://www.veselinastaneva.com/mamatalksmoney/" target="_blank">
            <img src="@/assets/images/partners/logos/12.png" alt=""/>
          </a>
        </div>
        <div class="logo col-md-3">
          <a href="https://vedrimami.eu/" target="_blank">
            <img src="@/assets/images/partners/logos/13.png" alt=""/>
          </a>
        </div>
        <div class="logo col-md-3">
          <a href="https://rent-a-baba.com/" target="_blank">
            <img src="@/assets/images/partners/logos/14.png" alt=""/>
          </a>
        </div>
        <div class="logo col-md-3">
          <a href="https://www.selflove.bg/" target="_blank">
            <img src="@/assets/images/partners/logos/15.png" alt=""/>
          </a>
        </div>
        <div class="logo col-md-3">
          <a href="https://mammi.bg/" target="_blank">
            <img src="@/assets/images/partners/logos/20.png" alt=""/>
          </a>
        </div>
        <div class="logo col-md-3">
          <a href="https://ekfwomen.org/" target="_blank">
            <img src="@/assets/images/partners/logos/19.png" alt=""/>
          </a>
        </div>
        <div class="logo col-md-3">
          <a href="https://www.mental-wellbeing.eu/" target="_blank">
            <img src="@/assets/images/partners/logos/16.png" alt=""/>
          </a>
        </div>
        <div class="logo col-md-3">
          <a href="https://join.futurefemales.co/" target="_blank">
            <img src="@/assets/images/partners/logos/18.png" alt=""/>
          </a>
        </div>
        <div class="logo col-md-3">
          <a href="https://realfood.bg/" target="_blank">
            <img src="@/assets/images/partners/logos/21.png" alt=""/>
          </a>
        </div>
        <div class="logo col-md-3">
          <a href="https://www.facebook.com/profile.php?id=61555146184848&sk=about&locale=bg_BG" target="_blank">
            <img src="@/assets/images/partners/woman_foundation.jpeg" alt=""/>
          </a>
        </div>
        <div class="logo col-md-3">
          <a href="https://maikomila.bg/" target="_blank">
            <img src="@/assets/images/partners/maikomila.jpg" alt=""/>
          </a>
        </div>
      </div>
    </div>
  </div>
  <FooterComponent :show-logos="false"/>
</template>

<style lang="scss" scoped>
.luma-embed-container {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 18px;
  padding-left: 14px;
  padding-right: 14px;
}

.luma-embed {
  width: 100%;
  max-width: 1400px;
}

.luma-embed iframe {
  width: 100%;
  max-width: none;
  height: 600px;
}

@media (max-width: 768px) {
  .luma-embed iframe {
    height: 520px;
  }
}

.partners-title {
  font-family: $font-semi-bold;
  color: $color-purple;
}
.d-md-flex {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: 692px) {
    flex-direction: column;
    align-items: center;
  }
}

.logo {
  //max-width: 150px;
  //display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  margin-bottom: 50px;
  text-align: center;

  img {
    max-width: 100%;
    max-height: 100%;
  }

  @media (max-width: 692px) {
    margin: 15px 0;
  }
}

</style>
